<router-outlet></router-outlet>

<img class="heart" src="../../../assets/img/login/heart.svg" alt="Atenea heart">
